import { useState } from "react";
import { Reveal } from "./Reveal";

export function NoiseMeter() {
  const [level, setLevel] = useState(38);
  const isCompliant = level <= 50;

  return (
    <Reveal className={`noise-meter ${isCompliant ? "is-compliant" : "is-violation"}`} delay={0.24}>
      <div className="noise-meter-header">
        <span>INTERACTIVE NOISE METER</span>
        <strong data-testid="noise-meter-status">{isCompliant ? "QUIET HOURS COMPLIANT" : "AUDIT THRESHOLD EXCEEDED"}</strong>
      </div>
      <div className="noise-meter-readout">
        <div data-testid="noise-meter-current-level">
          <small>CURRENT SIGNAL</small>
          <strong>{level} dB</strong>
        </div>
        <div data-testid="noise-meter-legal-limit">
          <small>LEGAL LIMIT</small>
          <strong>50 dB</strong>
        </div>
      </div>
      <div className="noise-gauge" aria-hidden="true">
        <div className="noise-gauge-fill" style={{ width: `${level}%` }} />
        <span className="noise-threshold" />
        <span className="noise-tick tick-zero">0</span>
        <span className="noise-tick tick-quarter">25</span>
        <span className="noise-tick tick-half">50</span>
        <span className="noise-tick tick-three-quarter">75</span>
        <span className="noise-tick tick-full">100</span>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={level}
        onChange={(event) => setLevel(Number(event.target.value))}
        aria-label="Adjust noise level in decibels"
        data-testid="noise-meter-slider"
      />
      <p data-testid="noise-meter-description">
        {isCompliant
          ? "Signal remains below the Silent Night threshold. Residential movement may continue under acoustic camouflage."
          : "Signal exceeds the 50 dB ordinance limit. The security ledger records the breach and an auditor may be dispatched."}
      </p>
    </Reveal>
  );
}
